import { render, staticRenderFns } from "./standaloneStepMenu.vue?vue&type=template&id=6c849d1f&scoped=true"
import script from "./standaloneStepMenu.vue?vue&type=script&lang=js"
export * from "./standaloneStepMenu.vue?vue&type=script&lang=js"
import style0 from "./standaloneStepMenu.vue?vue&type=style&index=0&id=6c849d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c849d1f",
  null
  
)

export default component.exports